/** PPR-3 F · 同行事件行列表（同行详情「未处理事件」和客户经理工作台「同行事件待处理」队列共用）：紧急标红，点订单号进订单详情回复。 */
import { Link } from "react-router-dom";
import { EVENT_STATUS_TONE, type PartnerEventRow } from "@/services/partnerEvents";

const fmt = (iso: string) => new Date(iso).toLocaleString("zh-CN", { hour12: false, month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit" });

export function PartnerEventRows({ rows, empty, showPartner }: { rows: PartnerEventRow[]; empty: string; showPartner: boolean }) {
  if (rows.length === 0) return <p className="text-[12.5px] text-slate-400" data-testid="events-empty">{empty}</p>;
  return (
    <ul className="flex flex-col gap-2">
      {rows.map((e) => (
        <li key={e.id} data-testid="event-row" className={`rounded-lg border px-3 py-2.5 ${e.urgency === "urgent" ? "border-rose-200 bg-rose-50/50" : "border-slate-200"}`}>
          <div className="flex flex-wrap items-center gap-2 text-[12px]">
            <b className="text-[13px] text-slate-900">{e.type_label}</b>
            {e.urgency === "urgent" && <span className="rounded-full bg-rose-100 px-2 py-0.5 font-semibold text-rose-700">紧急</span>}
            <span className={`rounded-full px-2 py-0.5 font-medium ${EVENT_STATUS_TONE[e.status] ?? EVENT_STATUS_TONE.open}`}>{e.status_label}</span>
            {showPartner && <span className="font-medium text-slate-700">{e.partner_name}</span>}
            <span className="text-slate-400">{fmt(e.created_at)}</span>
          </div>
          <p className="mt-1 line-clamp-2 whitespace-pre-wrap text-[12.5px] text-slate-600">{e.content}</p>
          <div className="mt-1.5 flex flex-wrap items-center gap-x-3 text-[11.5px] text-slate-500">
            <Link to={`/orders/${e.order_id}#partner-events`} className="font-medium text-blue-600 hover:underline">{e.order_no}</Link>
            {e.partner_ref && <span>同行单号 {e.partner_ref}</span>}
            {e.travel_date && <span>出发 {e.travel_date}</span>}
          </div>
        </li>
      ))}
    </ul>
  );
}
